var _title, _title2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 76,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 1)"
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "background")), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 602,
    width: 802,
    y: -1,
    x: -1,
    style: {
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -35.566971, 8.76459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-18",
    strokeMiterlimit: 10,
    stroke: "#D47616",
    fill: "#D47416",
    d: "M 78.683 25.808 L 77.97 37.385 L 84.204 28.079 L 78.683 25.808 Z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-19",
    strokeMiterlimit: 10,
    stroke: "#EAC311",
    fill: "#EBC310",
    d: "M 96.128 38.035 L 92.709 27.901 L 84.24 28.124 L 96.128 38.035 Z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-20",
    strokeMiterlimit: 10,
    stroke: "#DA8B15",
    fill: "#DA8B15",
    d: "M 84.24 28.106 L 92.709 27.901 L 85.148 24.588 L 84.24 28.106 Z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-21",
    strokeMiterlimit: 10,
    stroke: "#D26F16",
    fill: "#D37116",
    d: "M 78.71 10.01 L 78.71 25.808 L 85.175 24.57 L 78.71 10.01 Z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-22",
    fill: "#D4AA58",
    d: "M 77.97 37.412 L 78.407 48.935 L 96.128 38.035 L 77.97 37.412 Z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-23",
    strokeMiterlimit: 10,
    stroke: "#E3C393",
    fill: "#E3C393",
    d: "M 77.97 37.412 L 78.407 48.935 L 61.291 52.079 L 77.97 37.412 Z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-24",
    strokeMiterlimit: 10,
    stroke: "#E2C074",
    fill: "#E2C074",
    d: "M 77.97 37.412 L 61.291 52.079 L 56.464 43.93 L 77.97 37.412 Z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-25",
    fill: "#D47616",
    d: "M 49.411 27.847 L 65.236 16.003 L 52.261 39.941 L 49.411 27.847 Z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-26",
    strokeMiterlimit: 10,
    stroke: "#DB8E15",
    fill: "#DB8E15",
    d: "M 78.71 10.01 L 78.71 25.808 L 64.897 16.395 L 78.71 10.01 Z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-27",
    fill: "#DC9015",
    d: "M 58.45 13.359 L 64.693 16.413 L 49.928 27.456 L 58.45 13.359 Z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-28",
    strokeMiterlimit: 10,
    stroke: "#8F2E19",
    fill: "#8F2E19",
    d: "M 64.897 16.395 L 78.71 10.01 L 75.798 1.746 L 64.897 16.395 Z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-29",
    strokeMiterlimit: 10,
    stroke: "#DFA417",
    fill: "#DFA417",
    d: "M 52.305 39.629 L 56.464 43.93 L 77.97 37.385 L 52.305 39.629 Z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-30",
    strokeMiterlimit: 10,
    stroke: "#D37116",
    fill: "#D26F16",
    d: "M 52.305 39.629 L 77.97 37.412 L 64.897 16.395 L 52.305 39.629 Z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-31",
    strokeMiterlimit: 10,
    stroke: "#DB8E15",
    fill: "#DB8D15",
    d: "M 84.24 28.106 L 96.128 38.035 L 77.97 37.412 L 84.24 28.106 Z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-32",
    strokeMiterlimit: 10,
    stroke: "#CE6717",
    fill: "#CE6717",
    d: "M 64.897 16.395 L 77.97 37.412 L 78.683 25.835 L 64.897 16.395 Z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-33",
    strokeMiterlimit: 10,
    stroke: "#5D1604",
    fill: "#5D1604",
    d: "M 85.148 24.57 L 84.258 28.132 L 82.975 26.298 L 78.701 25.835 L 85.148 24.57 Z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-34",
    strokeMiterlimit: 10,
    stroke: "#B14E1D",
    fill: "#B14E1D",
    d: "M 58.414 13.207 L 64.897 16.395 L 75.798 1.746 L 58.414 13.207 Z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -0.754307, -0.962479)"
  }, _title2 || (_title2 = /*#__PURE__*/React.createElement("title", null, "Layer 1")), /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    fill: "#D47416",
    d: "M 43.781 35.574 L 43.071 47.103 L 49.27 37.834 L 43.781 35.574 Z",
    fillRule: "evenodd",
    style: {
      stroke: "rgb(212, 117, 22)",
      strokeMiterlimit: 13,
      strokeLinecap: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    fill: "#EBC310",
    d: "M 61.123 47.749 L 57.723 37.658 L 49.304 37.879 L 61.123 47.749 Z",
    fillRule: "evenodd",
    style: {
      stroke: "rgb(212, 117, 22)",
      strokeMiterlimit: 13,
      strokeLinecap: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    fill: "#DA8B15",
    d: "M 49.304 37.862 L 57.723 37.658 L 50.208 34.358 L 49.304 37.862 Z",
    fillRule: "evenodd",
    style: {
      stroke: "rgb(212, 117, 22)",
      strokeMiterlimit: 13,
      strokeLinecap: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-4",
    fill: "#D37116",
    d: "M 43.806 19.841 L 43.806 35.574 L 50.233 34.342 L 43.806 19.841 Z",
    fillRule: "evenodd",
    style: {
      stroke: "rgb(212, 117, 22)",
      strokeMiterlimit: 13,
      strokeLinecap: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-5",
    fill: "#D4AA58",
    d: "M 43.071 47.128 L 43.506 58.604 L 61.123 47.749 L 43.071 47.128 Z",
    fillRule: "evenodd",
    style: {
      stroke: "rgb(212, 117, 22)",
      strokeMiterlimit: 13,
      strokeLinecap: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-6",
    fill: "#E3C393",
    d: "M 43.071 47.128 L 43.506 58.604 L 26.492 61.735 L 43.071 47.128 Z",
    fillRule: "evenodd",
    style: {
      stroke: "rgb(212, 117, 22)",
      strokeMiterlimit: 13,
      strokeLinecap: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-7",
    fill: "#E2C074",
    d: "M 43.071 47.128 L 26.492 61.735 L 21.695 53.62 L 43.071 47.128 Z",
    fillRule: "evenodd",
    style: {
      stroke: "rgb(212, 117, 22)",
      strokeMiterlimit: 13,
      strokeLinecap: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-8",
    fill: "#D47616",
    d: "M 14.684 37.604 L 30.414 25.811 L 17.517 49.647 L 14.684 37.604 Z",
    fillRule: "evenodd",
    style: {
      stroke: "rgb(212, 117, 22)",
      strokeMiterlimit: 13,
      strokeLinecap: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-9",
    fill: "#DB8E15",
    d: "M 43.806 19.841 L 43.806 35.574 L 30.078 26.201 L 43.806 19.841 Z",
    fillRule: "evenodd",
    style: {
      stroke: "rgb(212, 117, 22)",
      strokeMiterlimit: 13,
      strokeLinecap: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-10",
    fill: "#DC9015",
    d: "M 23.669 23.177 L 29.874 26.216 L 15.197 37.214 L 23.669 23.177 Z",
    fillRule: "evenodd",
    style: {
      stroke: "rgb(212, 117, 22)",
      strokeMiterlimit: 13,
      strokeLinecap: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-11",
    fill: "#8F2E19",
    d: "M 30.078 26.2 L 43.806 19.841 L 40.913 11.613 L 30.078 26.2 Z",
    fillRule: "evenodd",
    style: {
      stroke: "rgb(212, 117, 22)",
      strokeMiterlimit: 13,
      strokeLinecap: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-12",
    fill: "#DFA417",
    d: "M 17.562 49.337 L 21.695 53.62 L 43.071 47.103 L 17.562 49.337 Z",
    fillRule: "evenodd",
    style: {
      stroke: "rgb(212, 117, 22)",
      strokeMiterlimit: 13,
      strokeLinecap: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-13",
    fill: "#D26F16",
    d: "M 17.562 49.337 L 43.071 47.128 L 30.078 26.201 L 17.562 49.337 Z",
    fillRule: "evenodd",
    style: {
      stroke: "rgb(212, 117, 22)",
      strokeMiterlimit: 13,
      strokeLinecap: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-14",
    fill: "#DB8D15",
    d: "M 49.304 37.862 L 61.123 47.749 L 43.071 47.128 L 49.304 37.862 Z",
    fillRule: "evenodd",
    style: {
      stroke: "rgb(212, 117, 22)",
      strokeMiterlimit: 13,
      strokeLinecap: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-15",
    fill: "#CE6717",
    d: "M 30.078 26.201 L 43.071 47.128 L 43.781 35.6 L 30.078 26.201 Z",
    fillRule: "evenodd",
    style: {
      stroke: "rgb(212, 117, 22)",
      strokeMiterlimit: 13,
      strokeLinecap: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-16",
    fill: "#5D1604",
    d: "M 50.208 34.342 L 49.322 37.888 L 48.048 36.062 L 43.798 35.6 L 50.208 34.342 Z",
    fillRule: "evenodd",
    style: {
      stroke: "rgb(212, 117, 22)",
      strokeMiterlimit: 13,
      strokeLinecap: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-17",
    fill: "#B14E1D",
    d: "M 23.633 23.025 L 30.078 26.2 L 40.913 11.613 L 23.633 23.025 Z",
    fillRule: "evenodd",
    style: {
      stroke: "rgb(212, 117, 22)",
      strokeMiterlimit: 13,
      strokeLinecap: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    strokeMiterlimit: 10,
    stroke: "#D47616",
    fill: "#D47416",
    d: "m43.68028,35.47466l-0.7125,11.5768l6.2337,-9.306l-5.5212,-2.2708z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    strokeMiterlimit: 10,
    stroke: "#EAC311",
    fill: "#EBC310",
    d: "m61.12558,47.70156l-3.4196,-10.1342l-8.4689,0.2227l11.8885,9.9115z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    strokeMiterlimit: 10,
    stroke: "#EAC311",
    fill: "#EAC511",
    d: "m74.60818,47.50566l-4.2211,0.3028l-12.6811,-10.2411l16.9022,9.9383z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    strokeMiterlimit: 10,
    stroke: "#DB8D15",
    fill: "#DA8B15",
    d: "m57.70598,37.56736l3.4196,10.152l9.2615,0.1069l-12.6811,-10.2589z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_7",
    strokeMiterlimit: 10,
    stroke: "#DA8B15",
    fill: "#DA8B15",
    d: "m49.23708,37.77226l8.4689,-0.2049l-7.5605,-3.3127l-0.9084,3.5176z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_8",
    strokeMiterlimit: 10,
    stroke: "#D26F16",
    fill: "#D37116",
    d: "m43.70698,19.67676l0,15.7979l6.4652,-1.2378l-6.4652,-14.5601z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_9",
    strokeMiterlimit: 10,
    stroke: "#EAC511",
    fill: "#EAC311",
    d: "m43.71588,19.67676l6.4385,14.5601l7.5605,3.3305l-13.999,-17.8906z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_11",
    strokeMiterlimit: 10,
    stroke: "#AC7534",
    fill: "#AC7534",
    d: "m65.48918,54.70996l8.2106,-3.6778l-3.3127,-3.2237l-4.8979,6.9015z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_12",
    strokeMiterlimit: 10,
    stroke: "#5D1604",
    fill: "#57170A",
    d: "m74.60818,47.50566l-0.8906,3.5621l-3.3305,-3.2593l4.2211,-0.3028z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_13",
    strokeMiterlimit: 10,
    stroke: "#E2C99F",
    fill: "#E2C99F",
    d: "M 60.756 47.703 L 65.504 54.71 L 70.372 47.808 L 60.756 47.703 Z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    },
    transform: "matrix(0.99999, 0.004367, -0.004367, 0.99999, 0.224228, -0.286583)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_14",
    fill: "#D4AA58",
    d: "m42.96778,47.07816l0.4364,11.5234l17.7214,-10.9l-18.1578,-0.6234z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_15",
    strokeMiterlimit: 10,
    stroke: "#E3C393",
    fill: "#E3C393",
    d: "m43.40418,58.60156l-12.7078,5.5302l-4.4081,-2.3866l17.1159,-3.1436z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_16",
    strokeMiterlimit: 10,
    stroke: "#DFC9A4",
    fill: "#DFC9A4",
    d: "M 25.576 73.358 L 26.288 61.604 L 30.755 64.04 L 25.576 73.358 Z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_17",
    strokeMiterlimit: 10,
    stroke: "#E0C9A4",
    fill: "#E0C9A4",
    d: "M 33.813 75.076 L 30.696 63.777 L 43.404 58.602 L 33.813 75.076 L 33.813 75.076 Z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_18",
    strokeMiterlimit: 10,
    stroke: "#E3C393",
    fill: "#E3C393",
    d: "m42.96778,47.07816l0.4364,11.5234l-17.1159,3.1436l16.6795,-14.667z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_10",
    strokeMiterlimit: 10,
    stroke: "#E4D3B9",
    fill: "#E4D3B9",
    d: "m61.12558,47.70156l4.3636,7.0084l-22.085,3.8916l17.7214,-10.9z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_19",
    strokeMiterlimit: 10,
    stroke: "#E2C074",
    fill: "#E2C074",
    d: "m42.96778,47.07816l-16.6795,14.667l-4.8266,-8.1483l21.5061,-6.5187z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_20",
    strokeMiterlimit: 10,
    stroke: "#E9DABE",
    fill: "#E9DABE",
    d: "m20.53548,67.55136l0.8905,-13.9278l4.8267,8.1216l-5.7172,5.8062z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_21",
    fill: "#D47616",
    d: "m14.40868,37.51396l15.8246,-11.844l-12.9749,23.9373l-2.8497,-12.0933z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_22",
    fill: "#D47416",
    d: "m29.89488,26.06186l-12.592,23.2338l-2.7695,-11.7283l15.3615,-11.5055zm0.6857,-0.7926l-0.8192,0.6145l-15.3616,11.4966l-0.1158,0.0891l0,0.1425l2.7696,11.7371l0.1335,0.5699l0.285,-0.5165l12.6188,-23.2338l0.4897,-0.8905l0,-0.0089z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_23",
    strokeMiterlimit: 10,
    stroke: "#DB8E15",
    fill: "#DB8E15",
    d: "m43.70698,19.67676l0,15.7979l-13.8121,-9.4128l13.8121,-6.3851z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_24",
    strokeMiterlimit: 10,
    stroke: "#EAC311",
    fill: "#EBBE10",
    d: "m0.39183,39.34846l14.14155,-1.7811l8.9052,-14.6847l-23.04675,16.4658z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_25",
    fill: "#DC9015",
    d: "m23.44748,23.02516l6.2426,3.0545l-14.7649,11.0425l8.5223,-14.097z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_26",
    fill: "#DB8E15",
    d: "m23.49208,23.16766l5.9843,2.9298l-14.1594,10.5794l8.1751,-13.5271l0,0.0179zm-0.0802,-0.3117l-8.8785,14.7114l15.3615,-11.5055l-6.483,-3.1881l0,-0.0178z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_27",
    strokeMiterlimit: 10,
    stroke: "#8F2E19",
    fill: "#8F2E19",
    d: "m29.89488,26.06176l13.8121,-6.385l-2.912,-8.2641l-10.9001,14.6491z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_28",
    strokeMiterlimit: 10,
    stroke: "#6B180E",
    fill: "#6B180E",
    d: "m38.08778,0.44142l2.6715,10.97124l-17.3474,11.4611l14.6759,-22.43234z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_29",
    strokeMiterlimit: 10,
    stroke: "#A0331A",
    fill: "#A0331A",
    d: "m50.73318,4.54674l-7.0084,15.13892l-2.912,-8.2641l9.9204,-6.87482z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_30",
    strokeMiterlimit: 10,
    stroke: "#DF9A14",
    fill: "#DF9A14",
    d: "m10.03618,50.20396l7.2667,-0.8905l-2.7695,-11.7461l-4.4972,12.6366z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_31",
    strokeMiterlimit: 10,
    stroke: "#E3B84F",
    fill: "#E3B84F",
    d: "m14.61348,54.87916l6.8482,-1.2823l-4.1588,-4.328l-2.6894,5.6103z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_32",
    strokeMiterlimit: 10,
    stroke: "#DFA417",
    fill: "#DFA417",
    d: "m17.30288,49.29566l4.1588,4.3012l21.5061,-6.5454l-25.6649,2.2442z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_33",
    strokeMiterlimit: 10,
    stroke: "#D37116",
    fill: "#D26F16",
    d: "m17.30288,49.29556l25.6649,-2.2174l-13.0729,-21.0163l-12.592,23.2337z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_34",
    strokeMiterlimit: 10,
    stroke: "#DB8E15",
    fill: "#DB8D15",
    d: "M 49.237 37.772 L 60.712 47.583 L 42.968 47.078 L 49.237 37.772 Z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_35",
    strokeMiterlimit: 10,
    stroke: "#CE6717",
    fill: "#CE6717",
    d: "m29.89488,26.06186l13.0729,21.0163l0.7125,-11.5768l-13.7854,-9.4395z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_36",
    strokeMiterlimit: 10,
    stroke: "#9D2E1A",
    fill: "#9D2E1A",
    d: "m49.23708,37.77226l-5.5568,-2.2976l4.604,0.4542l0.9528,1.8434z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_37",
    strokeMiterlimit: 10,
    stroke: "#5D1604",
    fill: "#5D1604",
    d: "m50.14548,34.23686l-0.8905,3.5621l-1.2824,-1.8345l-4.2745,-0.4631l6.4474,-1.2645z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_38",
    strokeMiterlimit: 10,
    stroke: "#B14E1D",
    fill: "#B14E1D",
    d: "m23.41188,22.87376l6.483,3.188l10.9001,-14.6491l-17.3831,11.4611z",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.edbfd7914564fd1104fbfe0b81d38aac.svg";
export { ForwardRef as ReactComponent };